"use client"
import { useState, useEffect, useCallback } from "react"
import { signOut, useSession } from "@hono/auth-js/react"
import { sessionTimeout } from "@/backend/config";
import { Clock } from "lucide-react";
import { cn } from "@/lib/utils";

export const SESSION_TIMEOUT_SECOUNDS = sessionTimeout();

export const SessionCountDown = () => {
  const { data: session, status } = useSession()
  const [timeLeft, setTimeLeft] = useState(SESSION_TIMEOUT_SECOUNDS)
  const [lastActivity, setLastActivity] = useState(Date.now())
  const [toggle, setToggle] = useState(false)

  const resetTimer = useCallback(() => {
    setLastActivity(Date.now())
    setTimeLeft(SESSION_TIMEOUT_SECOUNDS)
  }, [])

  useEffect(() => {
    if (status === 'authenticated') {
      const interval = setInterval(() => {
        const elapsed = Math.floor((Date.now() - lastActivity) / 1000)

        const remaining = SESSION_TIMEOUT_SECOUNDS - elapsed;

        setTimeLeft(remaining)

        if (remaining <= 0) {
          clearInterval(interval)
          signOut({ callbackUrl: '/sign-in', redirect: true })
        }
      }, 1000)

      const activityEvents = [
        'mousemove',
        'keydown',
        'scroll',
        'click',
        'touchstart'
      ]
      activityEvents.forEach((event) => window.addEventListener(event, resetTimer))

      return () => {
        clearInterval(interval)
        activityEvents.forEach((event) => window.removeEventListener(event, resetTimer))
      }
    } else {
      setTimeLeft(SESSION_TIMEOUT_SECOUNDS)
    }

  }, [status, lastActivity, resetTimer])


  if (status !== "authenticated") return null


  const minutes = Math.floor(timeLeft / 60)
  const seconds = timeLeft % 60


  return (
    <>
      <div className="relative ">
        <div className="absolute bottom-0 right-0">
          <div className={cn(toggle ? 'w-[350px]  animate-in transition-all ' : "w-[35px] animate-out transition-all", "bg-gray-800 h-[35px] rounded-s-full")} onClick={() => setToggle(!toggle)}>
            <div className="w-full h-full flex items-center pl-2">
              <Clock className="text-gray-400 size-5" />
              {toggle && (
                <div className={cn(toggle ? 'transform transition-all opacity-100' : 'transition-all opacity-0', "text-gray-400 pl-2")}>
{/*                   <div className="hidden md:flex md:fixed lg:fixed bottom-4 right-4 bg-gray-800 text-white py-2 px-4 rounded-lg shadow-lg text-sm z-50" aria-live="polite"> */}
                    Munkamenet: <span className="font-bold">
                      {minutes.toString().padStart(2, "0")} : {" "}
                      {seconds.toString().padStart(2, "0")}
                    </span>
{/*                   </div> */}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
